<template>
  <div class="home">
<Navigation/>
    <div class="section bg-primary-3">
    <div class="container text-center">
      <h1>Email Signatures</h1>
      <div class="text-large">Add some style to your email.</div>
    </div>
  </div>
<Templates Category="e-mail-signatures" Workspace="extras" />


  </div>

</template>

<script>
import Navigation from "@/components/Navigation.vue"
import Templates from "@/components/TemplateCollection.vue"

export default {
  name: "home",
  components: {
    Navigation,
    Templates
  }
};
</script>
